import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Mic,
  Headphones,
  Clock,
  CreditCard,
  CheckCircle,
  Star,
  Check,
  X,
  Calendar,
  Clock as ClockIcon,
  EllipsisIcon,
} from "lucide-react";
import ModalCitasCliente from "../../../../components/elements/ModalCitasCliente";
import wave from "../../../../assets/wave.svg";
import { message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

export default function Podcast() {
  const { podcast } = useSelector((state) => state.podcast);
  const [selectedAppointment, setSelectedAppointment] = useState({
    day: null,
    time: null,
  });

  const [messageApi, contextHolder] = message.useMessage();

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Evento agregado correctamente!",
    });
  };

  const errorDate = () => {
    messageApi.open({
      type: "error",
      content: "Por favor, ingresa un nombre para la cita",
    });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleTimeSelect = (day, time) => {
    setSelectedAppointment({ day, time });
    console.log("Cita seleccionada:", { day, time });
  };

  const location = useLocation();

  const navigate = useNavigate();

  return (
    <div className="bg-background w-full px-10 font-poppina ">
      {contextHolder}

      <div className="w-full flex py-2  rounded gap-3 bg-background border-b ">
        <p
          onClick={() => navigate("/client")}
          className={`ml-4 cursor-pointer font-semibold ${
            decodeURIComponent(location.pathname) ===
            `/client/podcast/${podcast.nombre}`
              ? "text-indigo-700"
              : ""
          }`}
        >
          Cuenta
        </p>

        <p>Calendario</p>
      </div>

      <ModalCitasCliente
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        success={success}
        errorDate={errorDate}
      />

      {podcast.pago && (
        <div className="p-8 rounded-lg mt-10">
          <div className="podcast text-center mb-10 shadow rounded-lg  ">
            <div className="relative ">
              <img
                className="absolute w-full sm:h-[220px] h-[250px] object-cover rounded-lg "
                src={wave}
                alt=""
              />
              <div className="relative z-10  ">
                <h1 className="text-white sm:text-6xl text-3xl font-bold pt-16 font-poppins ">
                  {podcast.nombre}
                </h1>

                <div
                  onClick={() => setIsModalOpen(true)}
                  className="absolute bg-white top-5 px-4 py-2 rounded-lg right-10 flex items-center  transition duration-300 ease-in-out transform hover:scale-105 space-x-2"
                >
                  <Calendar className="w-6 h-6 z-10 text-blue-500" />
                  <button className=" text-blue-500  font-semibold text-lg ">
                    <p className="sm:block hidden">Agenda una cita</p>
                  </button>
                </div>
              </div>
            </div>

            <div className=" mt-24 p-8 relative rounded-lg   transform transition-all ">
              <p className="text-gray-600 dark:text-white text-xl font-light max-w-2xl mx-auto leading-relaxed">
                {podcast.descripcion}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105">
              <div className="flex items-center space-x-4">
                <div className="p-4 bg-blue-100 rounded-full shadow-md">
                  <Mic className="w-8 h-8 text-blue-500" />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-white">
                    Podcast transmitidos en la semana
                  </h2>
                  <p className="text-2xl font-bold text-white">150</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-500 to-green-600 p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105">
              <div className="flex items-center space-x-4">
                <div className="p-4 bg-green-100 rounded-full shadow-md">
                  <Headphones className="w-8 h-8 text-green-500" />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-white">
                    Total de podcast emitidos
                  </h2>
                  <p className="text-2xl font-bold text-white">1,200</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-500 to-purple-600 p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105">
              <div className="flex items-center space-x-4">
                <div className="p-4 bg-purple-100 rounded-full shadow-md">
                  <Clock className="w-8 h-8 text-purple-500" />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-white">
                    Horas emitidas
                  </h2>
                  <p className="text-2xl font-bold text-white">450</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {!podcast.pago && (
        <div className="mt-14 mb-44 px-4">
          <h2 className="sm:text-4xl text-2xl font-bold text-text mb-8 text-center md:text-left">
            Selecciona un plan de pago
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Plan Básico */}
            <div className="bg-background  dark:border-none p-6 rounded-lg w-full max-w-[400px] mx-auto shadow-lg border border-gray-200 text-center transform transition-all hover:shadow-xl">
              <div className="bg-blue-500 italic dark:text-black text-white font-poppina font-semibold w-[150px] absolute top-0 left-0 rounded-ss-lg rounded-ee-lg p-1">
                <p>$19.99/mes</p>
              </div>

              <div className="text-4xl dark:text-blue-500 mt-12 mb-3 flex justify-start font-semibold font-poppina">
                <h1>Plan Básico</h1>
              </div>
              <p className="block dark:text-white text-start font-bold font-poppina text-2xl">
                $19.99 por mes
              </p>
              <div className="flex justify-start font-poppina border-b pb-4">
                <p className="text-gray-600 text-sm mt-1">
                  Ideal para principiantes
                </p>
              </div>

              <div className="flex flex-row font-poppina text-base mt-5 ml-5">
                <ul className="list-disc dark:text-white">
                  <li className="text-start">Acceso a podcasts básicos</li>
                  <li className="text-start">Descarga de episodios</li>
                  <li>Sin acceso a contenido premium</li>
                </ul>
              </div>

              <div className="mt-9">
                <button className="font-poppina dark:text-black text-lg py-3 px-6 bg-blue-500 text-white font-semibold rounded-lg w-full md:w-fit shadow-md hover:bg-blue-600 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
                  Obtener Plan Básico
                </button>
              </div>

              <p className="text-gray-600 text-xs italic mt-8 text-start font-poppina">
                * Prueba gratis por 7 días.
              </p>
              <p className="text-gray-600 text-xs italic text-start font-poppina">
                * Cancela en cualquier momento.
              </p>
            </div>

            <div className="bg-background italic  dark:border-none p-6 rounded-lg w-full max-w-[400px] mx-auto shadow-lg border border-gray-200 text-center transform transition-all hover:shadow-xl">
              <div className="bg-purple-500 dark:text-black text-white font-poppina font-semibold w-[150px] absolute top-0 left-0 rounded-ss-lg rounded-ee-lg p-1">
                <p>$29.99/mes</p>
              </div>

              <div className="text-4xl dark:text-purple-500 mt-12 mb-3 flex justify-start font-semibold font-poppina">
                <h1>Plan Pro</h1>
              </div>
              <p className="block text-start dark:text-white font-bold font-poppina text-2xl">
                $29.99 por mes
              </p>
              <div className="flex justify-start font-poppina border-b pb-4">
                <p className="text-gray-600 text-sm mt-1">
                  Para usuarios avanzados
                </p>
              </div>

              <div className="flex flex-row font-poppina text-base mt-5 ml-5">
                <ul className="list-disc dark:text-white">
                  <li className="text-start">
                    Acceso a podcasts básicos y pro
                  </li>
                  <li className="text-start">Descarga de episodios</li>
                  <li className="text-start">Acceso a contenido exclusivo</li>
                </ul>
              </div>

              <div className="mt-9">
                <button className="font-poppina text-lg py-3 dark:text-black px-6 bg-purple-500 text-white font-semibold rounded-lg w-full md:w-fit shadow-md hover:bg-purple-600 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
                  Obtener Plan Pro
                </button>
              </div>

              <p className="text-gray-600 text-xs italic mt-8 text-start font-poppina">
                * Prueba gratis por 7 días.
              </p>
              <p className="text-gray-600 text-xs italic text-start font-poppina">
                * Cancela en cualquier momento.
              </p>
            </div>

            {/* Plan Premium */}
            <div className="bg-background  dark:border-none p-6 rounded-lg w-full max-w-[400px] mx-auto shadow-lg border border-gray-200 text-center transform transition-all hover:shadow-xl">
              <div className="bg-yellow-700 italic dark:text-black text-white font-poppina font-semibold w-[150px] absolute top-0 left-0 rounded-ss-lg rounded-ee-lg p-1">
                <p>$39.99/mes</p>
              </div>

              <div className="text-4xl dark:text-yellow-700 mt-12 mb-3 flex justify-start font-semibold font-poppina">
                <h1>Plan Premium</h1>
              </div>
              <p className="block dark:text-white text-start font-bold font-poppina text-2xl">
                $39.99 por mes
              </p>
              <div className="flex justify-start font-poppina border-b pb-4">
                <p className="text-gray-600 text-sm mt-1">
                  Para usuarios avanzados
                </p>
              </div>

              <div className="flex flex-row font-poppina text-base mt-5 ml-5">
                <ul className="list-disc dark:text-white">
                  <li className="text-start">
                    Acceso a podcasts básicos y pro
                  </li>
                  <li className="text-start">Descarga de episodios</li>
                  <li className="text-start">Contenido premium incluido</li>
                  <li>Acceso a eventos exclusivos</li>
                </ul>
              </div>

              <div className="mt-9">
                <button className="font-poppina text-lg py-3 px-6 dark:text-black bg-yellow-700 text-white font-semibold rounded-lg w-full md:w-fit shadow-md hover:bg-yellow-800 hover:shadow-lg hover:scale-105 transition duration-300 ease-in-out">
                  Obtener Plan Premium
                </button>
              </div>

              <p className="text-gray-600 text-xs italic mt-8 text-start font-poppina">
                * Prueba gratis por 7 días.
              </p>
              <p className="text-gray-600 text-xs italic text-start font-poppina">
                * Cancela en cualquier momento.
              </p>
            </div>
          </div>
        </div>
      )}

      {!podcast.pago && (
        <div className="bg-black bg-opacity-90 mb-5 p-8 rounded-lg mt-10 relative overflow-hidden">
          {/* Fondo con la onda */}
          <div className="absolute inset-0 z-0">
            <img
              className="w-full h-full object-cover opacity-20"
              src={wave}
              alt="Wave background"
            />
          </div>

          {/* Contenido principal */}
          <div className="relative z-10">
            <div className="podcast text-center mb-10 shadow rounded-lg">
              <div className="relative">
                <div className="relative">
                  <h1 className="text-white sm:text-6xl text-3xl font-bold pt-16 font-poppins">
                    {podcast.nombre}
                  </h1>
                </div>
              </div>

              <div className="mt-24 p-8 relative rounded-lg transform transition-all">
                <p className="text-gray-600 dark:text-white text-xl font-light max-w-2xl mx-auto leading-relaxed">
                  {podcast.descripcion}
                </p>
              </div>
            </div>

            <p className="text-white text-3xl font-semibold text-center mb-4">
              Desbloquea este contenido al tener un plan
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-blue-500 p-6 rounded-lg shadow-md relative opacity-50">
                <div className="flex items-center space-x-4">
                  <div className="p-3 bg-blue-100 rounded-full">
                    <Mic className="w-6 h-6 text-blue-500" />
                  </div>
                  <div>
                    <h2 className="text-lg font-semibold text-white">
                      Podcast transmitidos en la semana
                    </h2>
                    <p className="text-2xl font-bold text-white">150</p>
                  </div>
                </div>
              </div>

              <div className="bg-green-600 p-6 rounded-lg shadow-md relative opacity-50">
                <div className="flex items-center space-x-4">
                  <div className="p-3 bg-green-100 rounded-full">
                    <Headphones className="w-6 h-6 text-green-500" />
                  </div>
                  <div>
                    <h2 className="text-lg font-semibold text-white">
                      Total de podcast emitidos
                    </h2>
                    <p className="text-2xl font-bold text-white">1,200</p>
                  </div>
                </div>
              </div>

              <div className="bg-purple-600 p-6 rounded-lg shadow-md relative opacity-50">
                <div className="flex items-center space-x-4">
                  <div className="p-3 bg-purple-100 rounded-full">
                    <Clock className="w-6 h-6 text-purple-500" />
                  </div>
                  <div>
                    <h2 className="text-lg font-semibold text-white">
                      Horas emitidas
                    </h2>
                    <p className="text-2xl font-bold text-white">450</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
